import pdfIcon from 'assets/images/pdf.svg';
import audioIcon from 'assets/images/audio.svg';
import videoIcon from 'assets/images/video.svg';
import docIcon from 'assets/images/doc.svg';
import csvIcon from 'assets/images/csv.svg';
import defaultIcon from 'assets/images/default.svg';

import { FILE_MIME } from 'framework/files';

export { CROP_SIZES, ARTIFACT_ID } from 'framework/files';

/* Connecting mime types to file categories */
const FILE_CATEGORY = {
  PDF: {
    icon: pdfIcon,
    mimeTypes: [...FILE_MIME.PDF.mime],
  },
  AUDIO: {
    icon: audioIcon,
    mimeTypes: [...FILE_MIME.MP3.mime, ...FILE_MIME.AAC.mime, ...FILE_MIME.WAV.mime],
  },
  VIDEO: {
    icon: videoIcon,
    mimeTypes: [...FILE_MIME.MP4.mime, ...FILE_MIME.MOV.mime],
  },
  DOC: {
    icon: docIcon,
    mimeTypes: [...FILE_MIME.DOC.mime, ...FILE_MIME.DOCX.mime, ...FILE_MIME.RTF.mime],
  },
  CSV: {
    icon: csvIcon,
    mimeTypes: [...FILE_MIME.XLS.mime, ...FILE_MIME.XLSX.mime, ...FILE_MIME.CSV.mime],
  },
  DEFAULT: {
    icon: defaultIcon,
    mimeTypes: [],
  },
  IMG: {
    icon: defaultIcon,
    mimeTypes: [...FILE_MIME.JPG.mime, ...FILE_MIME.JPEG.mime, ...FILE_MIME.PNG.mime, ...FILE_MIME.GIF.mime],
  },
};

/* Connecting artifact types from API to file categories */
const API_FILE_TYPE = {
  image: {
    alias: 'image',
    category: FILE_CATEGORY.IMG,
  },
  pdf: {
    alias: 'pdf',
    category: FILE_CATEGORY.PDF,
  },
  mp3: {
    alias: 'mp3',
    category: FILE_CATEGORY.AUDIO,
  },
  aac: {
    alias: 'aac',
    category: FILE_CATEGORY.AUDIO,
  },
  wav: {
    alias: 'wav',
    category: FILE_CATEGORY.AUDIO,
  },
  docx: {
    alias: 'docx',
    category: FILE_CATEGORY.DOC,
  },
  doc: {
    alias: 'doc',
    category: FILE_CATEGORY.DOC,
  },
  rtf: {
    alias: 'rtf',
    category: FILE_CATEGORY.DOC,
  },
  mp4: {
    alias: 'mp4',
    category: FILE_CATEGORY.VIDEO,
  },
  csv: {
    alias: 'csv',
    category: FILE_CATEGORY.CSV,
  },
  xls: {
    alias: 'xls',
    category: FILE_CATEGORY.CSV,
  },
  xlsx: {
    alias: 'xlsx',
    category: FILE_CATEGORY.CSV,
  },
  default: {
    alias: 'default',
    category: FILE_CATEGORY.DEFAULT,
  },
};

export { FILE_CATEGORY, API_FILE_TYPE };
